import { tagscolumns, headersColumns, labelsColumns, customDimensionColumns, extensionElementsColumns, settingsColumns, globalRequestColumns, taxonomyDiemsnionValueColumns, historyLogColumns, reviewColumns, tagsAltColumns, contextSettingsColumns, dimensionValuesColumns } from "./customObjectsPreData";


const columnsMapping = {
    tags: tagscolumns,
    header: headersColumns,
    labels: labelsColumns,
    tableItems: labelsColumns,
    customDimensions: customDimensionColumns,
    dimensionValue: dimensionValuesColumns,
    elements: extensionElementsColumns,
    settings: settingsColumns,
    contextSettings: contextSettingsColumns,
    globalRequests: globalRequestColumns,
    taxonomyDimensionValues: taxonomyDiemsnionValueColumns,
    historyLog: historyLogColumns,
    review: reviewColumns,
    consistencyCheck: [],
};

export const getColumns = (selectTemplate: string) => {
    return columnsMapping[selectTemplate as keyof typeof columnsMapping];
};

export const getAlternativeColumnsMapping = (selectTemplate: string) => {
    switch (selectTemplate) {
        case "customLabels":
            return labelsColumns<{ id: string }>();
        case "customHeaders":
            return headersColumns<{ id: string }>();
        case "customTags":
            return tagsAltColumns<{ id: string }>();
        case "contexts":
            return contextSettingsColumns<{ id: string }>();
        case "customDimensionValues":
            return dimensionValuesColumns<{ id: string }>();
        default:
            return [];
    }
}